import * as React from 'react';
export const signedSvg = React.forwardRef(function signedSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.668.527a.749.749 0 0 1 .726.191l1.936 1.926.015.014 1.937 1.948c.19.19.262.467.191.726l-1.597 5.832a.75.75 0 0 1-.43.491L4.56 15.44a.749.749 0 0 1-.823-.16L2.24 13.784a.599.599 0 0 1-.013-.013L.718 12.253a.749.749 0 0 1-.158-.822l3.785-8.878c.09-.21.27-.368.491-.429L10.668.527Zm-7.91 11.655 3.55-3.548a2.71 2.71 0 0 1 2.372-4.01 2.71 2.71 0 0 1 2.705 2.707 2.71 2.71 0 0 1-4.021 2.365l-3.547 3.547.62.62 8.09-3.444 1.387-5.064-1.62-1.63a1.149 1.149 0 0 1-.009-.008l-1.64-1.63-5.064 1.387-3.445 8.08.623.628ZM7.832 8.19c.218.216.518.35.848.35.665 0 1.208-.544 1.208-1.21A1.21 1.21 0 0 0 8.68 6.123a1.21 1.21 0 0 0-1.208 1.208 1.204 1.204 0 0 0 .36.859Z',
    }),
  );
});
signedSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var signed = {
  category: 'icon',
  colorable: true,
  name: 'signed',
  svg: signedSvg,
};
